export enum ContentTypeEnum {
  TYPE_PHOTO = 0,
  TYPE_TEXT = 1,
  TYPE_ILLUSTRATION = 2,
  TYPE_UNDEFINED = 4,
  TYPE_AREA = 5,
  TYPE_BACKGROUND = 6,
}
